/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvitationConfig} from '../api'

 export const useQueryGetInvitationConfig = createReactQueryHook('getInvitationConfig', getInvitationConfig)
